import { createClient } from "@sanity/client";

export const clientCMSpet = createClient({
  projectId: "qr4ibpjn",
  dataset: process.env.REACT_APP_SANITY_DATASET,
  apiVersion: "2024-01-01",
  useCdn: false,
});
